package dairy.mynotes.reusablecomponents

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun EditIcon(
    modifier: Modifier,
    contentDescription: String
) {
    Icon(
        imageVector = Icons.Filled.Edit,
        contentDescription = contentDescription,
        modifier = modifier
    )
}
